import { Component, h } from 'preact';
import * as appStyles from '../../../assets/global.scss';
import Icon from '../../../common/Icon/Icon';
import { Properties, getKey, Key, TravelType } from '../../../common';
import { Row } from '../../../common/Layout/Layout';
import { withStyles, WithStyles } from '../../../style';
import { stopPropagation, isRadio } from '../../../utils';
import { FinText } from '../../../i18n';

export interface TravelTypeRadioProps extends Properties {
  value: TravelType;
  checked: boolean;
  onSelection: (travelClass: TravelType) => any;
}

type EffectiveProps = TravelTypeRadioProps & WithStyles;

@withStyles(appStyles)
export default class TravelTypeRadio extends Component<TravelTypeRadioProps> {
  setTravelType = (e: MouseEvent): void => {
    const { onSelection, value } = this.props;
    onSelection(value);

    // As navigating radio buttons with arrowKeys will fire click events
    // we check whether or not the event originates from keyboard navigation
    // (radio) or normal click and close the modal only if it's a genuine click
    if (!isRadio(e.target as HTMLElement)) {
      this.hideModal();
    }
  };

  handleKeyUp = (e: KeyboardEvent) => {
    if (getKey(e) === Key.ENTER) {
      stopPropagation(e);
      this.hideModal();
    }
  };

  hideModal = (): void => {
    const {
      modal: { hideModal },
    } = this.context;
    hideModal();
  };

  render({ value, checked, tx }: EffectiveProps): h.JSX.Element {
    return (
      <Row class={tx(this.props.class, `travelType-${value}`, 'flex--space-between')} grow={false} fill={false}>
        <input
          class={'is-vishidden'}
          id={`travelType-${value}`}
          type="radio"
          name="travelType"
          value={value}
          onKeyUp={this.handleKeyUp}
          checked={checked}
          autofocus={checked}
        />
        <label
          for={`travelType-${value}`}
          class={tx('cursor-pointer', 'font-body-1 ps-medium-y fill nordic-blue-900-text')}
          onClick={this.setTravelType}
        >
          <FinText id={`travelType.${value}`} />
        </label>
        {checked && <Icon class={tx('is-small nordic-blue-900-text')} iconName="checkmark" />}
      </Row>
    );
  }
}
